<template>
    <v-row no-gutters justify="center" align="center">
        <v-col cols="12" align="center" class="mb-5">
            <div class="font-weight-bold custom-teal-text text-h2 mb-5">
                MVP
            </div>
            <img
                v-if="player.image"
                :height="$vuetify.breakpoint.mobile ? '200px' : '350px'"
                :aspect-ratio="16/9"
                :src="`${assetsUrl}/${player.image}`"
                class="clickable"
                contain
                @click="$router.push({path:`/Player/${player.id}`})"
                @error="player.image = null"
            >
            <img
                v-else
                :height="$vuetify.breakpoint.mobile ? '200px' : '350px'"
                :aspect-ratio="16/9"
                :src="require('@/assets/main_logo.png')"
                contain
            >
            <div class="mvp-text font-weight-bold custom-teal-text">
                {{ `${player.name}` }}
            </div>
        </v-col>
        <v-col cols="12" align="center">
            <v-row class="pb-5" align="center" justify="center">
                <v-col
                    v-for="(stat, index) in stats"
                    :key="index"
                    cols="4"
                    md="1"
                    class=" mx-0 px-5"
                    style="text-transform: capitalize;"
                    align="center"
                >
                    <div class="circle-border" style="background: #232323;">
                        <div class="secondary-font text-h6 white--text">
                            {{ player.stats[0][stat.value] }}
                        </div>
                        <div class="custom-teal-text font-weight-bold">
                            {{ stat.text }}
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: {
            player: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                stats: [
                    { text: 'PTS', value: 'points' },
                    { text: 'TR', value: 'rebounds' },
                    { text: 'AST', value: 'assists' },
                    { text: 'STL', value: 'steals' },
                    { text: 'TO', value: 'turnovers' },
                    { text: 'BLK', value: 'blockedShots' }
                ],
                assetsUrl: 'https://storage.googleapis.com'
            }
        }
    }
</script>

<style scoped>
.circle-border {
    border-radius: 50%;
    border: 5px solid teal;
    width: 90px;
    height: 90px;
    padding: 15px;
    background: #fff;
    text-align: center;
}

.text-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    letter-spacing: normal !important;
    font-family: Arial, sans-serif !important;
}

.mvp-text {
    font-size: 2rem !important;
    letter-spacing: normal !important;
    font-family: Arial, sans-serif !important;
}

.text-h4 {
    font-size: 2.125rem !important;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
}

.top-arc {
    border-width: 2px;
    border-radius: 10px 5% / 20px 25em 30px 35em;
    border-color: teal;
}
</style>
